import React, { useState, useRef } from "react";
import Icon from "~/Common-Objects/UI/Icon";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;


export default function EmailChipsInput({
    value = [],
    onChange = () => {},
    placeholder = "Type an email"
}) {
    const [inputValue, setInputValue] = useState("");
    const inputRef = useRef(null);

    const emails = Array.isArray(value) ? value : [];

    const addEmails = (raw) => {
        if (!raw) return;

        const candidates = raw
            .split(/[,\n]/)
            .map(e => e.trim())
            .filter(Boolean);

        const valid = [];
        const invalid = [];

        for (const email of candidates) {
            if (EMAIL_REGEX.test(email) && !emails.includes(email)) {
                valid.push(email);
            } else if (!EMAIL_REGEX.test(email)) {
                invalid.push(email);
            }
        }

        if (valid.length) {
            onChange([...emails, ...valid]);
        }

        if (invalid.length) {
            flashInvalid();
        }

        setInputValue("");
    };

    const removeEmail = (emailToRemove) => {
        onChange(emails.filter(email => email !== emailToRemove));
    };

    const flashInvalid = () => {
        if (!inputRef.current) return;
        inputRef.current.classList.add("inbox-composer__ccTag_text_incorrect");
        setTimeout(() => {
            inputRef.current?.classList.remove("inbox-composer__ccTag_text_incorrect");
        }, 1000);
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter" || e.key === ",") {
            e.preventDefault();
            addEmails(inputValue);
        }
    };

    const handlePaste = (e) => {
        const pasted = e.clipboardData.getData("text");
        if (pasted.includes(",") || pasted.includes("\n")) {
            e.preventDefault();
            addEmails(pasted);
        }
    };

    const handleBlur = () => {
        if (EMAIL_REGEX.test(inputValue.trim())) {
            addEmails(inputValue);
        }
    };

    return (
        <div style={{ width: "100%" }}>
            <div
                style={{
                    width: "100%",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 5,
                    cursor: "text"
                }}
                onClick={() => inputRef.current?.focus()}
            >
                {emails.map(email => (
                    <div className="inbox-composer__ccTag" key={email}>
                        <div className="inbox-composer__ccTag_text">
                            {email}
                        </div>
                        <div className="inbox-composer__ccTag_icon">
                            <Icon
                                name="cross"
                                width="15"
                                style={{ cursor: "pointer" }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    removeEmail(email);
                                }}
                            />
                        </div>
                    </div>
                ))}

                <input
                    ref={inputRef}
                    type="text"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    onKeyDown={handleKeyDown}
                    onPaste={handlePaste}
                    onBlur={handleBlur}
                    placeholder={placeholder}
                    style={{
                        flex: 1,
                        minWidth: 120,
                        border: "none",
                        outline: "none",
                        padding: "5px"
                    }}
                />
            </div>
        </div>
    );
}
